import React from 'react';
import { useTranslation } from 'react-i18next';
export default function languageSwitcher(props) {
    var _a;
    var i18n = useTranslation().i18n;
    var changeLanguage = function (code) {
        console.log(code);
        i18n.changeLanguage(code);
        props.changeLang(code);
    };
    if (props.isToggleLang) {
        return (React.createElement("div", { className: 'row font-white lang-select-container' },
            React.createElement("div", { className: 'small-12 large-10 large-centered columns' },
                React.createElement("section", { className: 'lang-select-section right' },
                    React.createElement("ul", null, (_a = props === null || props === void 0 ? void 0 : props.langMap) === null || _a === void 0 ? void 0 : _a.map(function (l) { return (React.createElement("li", { key: l.key },
                        React.createElement("a", { onClick: function (e) { return changeLanguage(l.key); } }, l.name))); }))))));
    }
    return React.createElement(React.Fragment, null);
}
